import { useTranslation } from "react-i18next";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardFooter,
} from "~/components/ui/card";
import { Button } from "~/components/ui/button";

export function ApiCard() {
  const { t } = useTranslation();
  return (
    <Card className="shrink-0">
      <CardHeader>
        <CardTitle>{t("api_section_title")}</CardTitle>
        <CardDescription>
          {t("api_section_content")}
        </CardDescription>
      </CardHeader>
      <CardFooter>
        <Button asChild className="w-full">
          <a href="https://t.me/ObunaContact">@ObunaContact</a>
        </Button>
      </CardFooter>
    </Card>
  );
}
